import {apolloClient} from "@/apollo";
import {ADD_SYSTEM_USER, UPDATE_SYSTEM_USER} from "@/gql";

export const state = {
    loading: false,
    errors: [],
}
export const getters = {
    userAdministrationLoading: state => state.loading,
    userAdministrationErrors: state => state.errors
}
export const actions = {

    async addNewSystemUser({commit}, userData) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            let {data: {adminUser}} = await apolloClient.mutate({
                mutation: ADD_SYSTEM_USER,
                variables: userData
            })
            return adminUser.user
        } catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        } finally {
            commit('LOADING_FALSE')
        }
    },
    async updateSystemUser({commit}, userData) {
        commit('LOADING_TRUE')
        commit('REMOVE_ERRORS')
        try {
            let {data: {adminUser}} = await apolloClient.mutate({
                mutation: UPDATE_SYSTEM_USER,
                variables: userData
            })
            return adminUser.user
        } catch (e) {
            commit('SET_ERRORS', e.graphQLErrors)
        } finally {
            commit('LOADING_FALSE')
        }
    },
}
export const mutations = {
    LOADING_TRUE(state){
        state.loading = true
    },
    LOADING_FALSE(state){
        state.loading = false
    },
    SET_ERRORS(state, payload){
        state.errors = payload
    },
    REMOVE_ERRORS(state){
        state.errors = []
    }
}
